var map = {
	"./Contract.svg": 9443,
	"./Litigation.svg": 6351,
	"./Matter.svg": 4754,
	"./addappfromstore.svg": 9606,
	"./app-logo.svg": 70,
	"./attorney.svg": 8371,
	"./avatar.svg": 4194,
	"./blank.svg": 2081,
	"./cloud-mode.svg": 8988,
	"./cloud.svg": 2172,
	"./cloudexport.svg": 1494,
	"./envelope.svg": 7377,
	"./excel.svg": 102,
	"./html.svg": 8030,
	"./info.svg": 2073,
	"./key-lock.svg": 6298,
	"./legalmeeting.svg": 5007,
	"./lookup.svg": 4467,
	"./microsoft_logo.svg": 7979,
	"./norton.svg": 5225,
	"./onenote.svg": 6559,
	"./padlock.svg": 8725,
	"./pdf.svg": 6885,
	"./picture.svg": 3909,
	"./powerpoint.svg": 1858,
	"./server-mode.svg": 8836,
	"./server.svg": 2484,
	"./success-svgrepo-com.svg": 947,
	"./windows.svg": 4660,
	"./word.svg": 2321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8151;